import axios from 'axios'
import store from '@/store'

const http = axios.create({
  baseURL: '/api',
  timeout: 15000
})

function handleUnauthorized(requestToken) {
  if (requestToken && requestToken !== store.state.token) return
  store.commit('LOGOUT')
  store.commit('SET_DRAWER', false)
  if (window.location.hash !== '#/' && window.location.hash !== '#') {
    window.location.hash = '#/'
  }
}

// 请求拦截器 - 自动带上 Token
http.interceptors.request.use(config => {
  const token = store.state.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
    config.__authToken = token
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
http.interceptors.response.use(response => {
  const res = response.data
  if (res.code === 401) {
    handleUnauthorized(response.config && response.config.__authToken)
    return Promise.reject(new Error(res.message))
  }
  return res
}, error => {
  const response = error.response
  if (response && (response.status === 401 || (response.data && response.data.code === 401))) {
    handleUnauthorized(response.config && response.config.__authToken)
  }
  return Promise.reject(error)
})

export default http
